import React, { PureComponent } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './ActionBar.scss'
import Layout from "./Layout";

const Toggle = ({ onToggle, isVisible, showText }) => {
  if (isVisible) {
    return <CloseButton onClick={onToggle} small />
  }

  return (
    <Button textOnly onClick={onToggle} noMaxWidth>
      {showText || t('actionbar.toggle.show')}
    </Button>
  )
}

export default class ActionBar extends PureComponent {
  state = {
    isVisible: true
  }

  toggle = () => this.setState({ isVisible: !this.state.isVisible })

  render() {
    const { children, hideable, showButtonText, noShadow, ...rest } = this.props
    const { isVisible } = this.state

    if (!isVisible) {
      return (
        <Layout className={styles.root} white textCenter alignCenter justifyCenter {...rest}>
          <Toggle onToggle={this.toggle} isVisible={isVisible} showText={showButtonText} />
        </Layout>
      )
    }

    return (
      <Layout
        white
        className={cx({
          [styles.root]: true,
          [styles.shadow]: !noShadow
        })}
      >
        {hideable ? children({
          HideButton: <Toggle onToggle={this.toggle} isVisible={isVisible} />,
          onToggle: this.toggle,
          isVisible
        }) : children}
      </Layout>
    )
  }
}

ActionBar.propTypes = {
  children: PropTypes.any,
  hideable: PropTypes.bool,
  showButtonText: PropTypes.string
}
